import { Picture } from 'src/components/ui/Image'
import { ListingH1 } from 'src/components/plp/ListingH1'

type CollectionBannerProps = {
  imageBannerDesktop?: string
  imageBannerMobile?: string
  enableSession?: boolean
  h1?: string
  listingName?: string
  showListingH1?: boolean
}

export const CollectionBanner = ({
  imageBannerDesktop,
  imageBannerMobile,
  enableSession,
  h1,
  listingName,
  showListingH1,
}: CollectionBannerProps) => {
  if (!enableSession) {
    return null
  }

  const hasImage = Boolean(imageBannerDesktop || imageBannerMobile)
  const headingText = h1?.trim() || listingName || ''

  return (
    <div className="flex justify-center items-center ">
      {showListingH1 && hasImage && headingText ? (
        <ListingH1 text={headingText} variant="sr-only" />
      ) : null}
      <Picture
        sources={[
          {
            src: imageBannerMobile ?? '',
            width: 375,
            height: 120,
            media: '(max-width: 600px)',
          },
        ]}
        img={{
          src: imageBannerDesktop ?? '',
          width: 1440,
          height: 212,
          alt: 'Imagem do banner da coleção',
          className: 'max-w-full',
          loading: 'lazy',
        }}
      />
    </div>
  )
}
